
import React,{useState} from 'react';
import './PizzaItems.css'
import ItemsDisplay  from './ItemsDisplay';


const PizzaItems = ({title}) => {
    const [clicked, setclicked] = useState(false);
    return <div className= "pizzaitems_container">
        <div className="category_container">
        <h2>{title}</h2>  
        <button onClick={()=>{
            setclicked(!clicked) 
        }}>{clicked?'-':'+'}</button>  
        </div><br/>
      {clicked?<ItemsDisplay type={title}/>:null}
    
    </div>;
}
 
export default PizzaItems;